// extracted by mini-css-extract-plugin
export default {"root":"style_root__DxGsC","text":"style_text__yQVh2"};